<template>
  <div
    class="gender-selector flex flex-row justify-evenly items-center"
    :class="{ 'show-captions': showCaption }"
  >
    <div class="gender-wrapper" @click="$emit('input', 2)">
      <img
        v-if="value === 2"
        class="gender active"
        alt="Female"
        src="../../../assets/DefaultCloudzet/HomePage/rectangle_female.svg"
      />
      <img
        v-else
        class="gender"
        alt="Female"
        src="../../../assets/DefaultCloudzet/HomePage/rectangle_female_disable.svg"
      />
      <span class="caption">{{ $t('settingUserData.female') }}</span>
    </div>
    <div class="gender-wrapper" @click="$emit('input', 1)">
      <img
        v-if="value === 1"
        class="gender active"
        alt="Male"
        src="../../../assets/DefaultCloudzet/HomePage/rectangle_male.svg"
      />
      <img
        v-else
        class="gender"
        alt="Male"
        src="../../../assets/DefaultCloudzet/HomePage/rectangle_male_disable.svg"
      />
      <span class="caption">{{ $t('settingUserData.male') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenderSelector',
  props: {
    value: Number,
    showCaption: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.gender-selector {
  min-width: 130px;
  &.show-captions {
    .gender-wrapper {
      @apply mx-4;
      width: 60px;
    }
    .caption {
      display: inline;
    }
  }
}
.gender-wrapper {
  @apply flex flex-col items-center;
  height: 100%;
}
.gender {
  @apply inline-block h-full;
  border-radius: 10px;
  &.active {
    box-shadow: 0px 0px 6px rgba(67, 78, 108, 0.5);
  }
}
.caption {
  @apply mt-2;
  display: none;
}
</style>
